module.exports = __webpack_public_path__ + "img/pic5.4617dd66.png";